import type { RouteSEO } from "./routes";

function setMetaTag(
  attr: "name" | "property",
  key: string,
  content: string,
): void {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href: string): void {
  let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.href = href;
}

export function updateMeta(seo: RouteSEO): void {
  document.title = seo.title;
  setMetaTag("name", "description", seo.description);
  setMetaTag("name", "keywords", seo.keywords);
  setMetaTag("property", "og:title", seo.ogTitle);
  setMetaTag("property", "og:description", seo.ogDescription);
  setMetaTag("property", "og:type", seo.ogType);
  setMetaTag("property", "og:url", seo.canonical);
  setMetaTag("property", "og:image", seo.ogImage);
  setMetaTag("name", "twitter:card", "summary_large_image");
  setMetaTag("name", "twitter:title", seo.ogTitle);
  setMetaTag("name", "twitter:description", seo.ogDescription);
  setMetaTag("name", "twitter:image", seo.ogImage);
  setCanonical(seo.canonical);
}

export function injectJsonLd(data: object): void {
  const existing = document.querySelector(
    'script[type="application/ld+json"][data-seo]',
  );
  if (existing) existing.remove();

  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.setAttribute("data-seo", "true");
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}
